module.exports = __webpack_public_path__ + "img/category.67548b94.svg";